import { render, staticRenderFns } from "./Form212_v2.vue?vue&type=template&id=d32512aa&scoped=true&"
import script from "./Form212_v2.vue?vue&type=script&lang=js&"
export * from "./Form212_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form212_v2.vue?vue&type=style&index=0&id=d32512aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32512aa",
  null
  
)

export default component.exports